module.exports = __webpack_public_path__ + "static/media/activity-character-sound_x3.a2d2573d.mp3";